export default {
  modal: 'Selecione a area da imagem que será feita a leitura pelo OCR.',
  ok: 'Iniciar',
};
